/** ----------------------------------------
 Meesterbaan
 ---------------------------------------- */

/**
 * Gets all the vacatures from Meesterbaan and shows them.
 */

import axios from 'axios';

export default class Meesterbaan {

    constructor(element, loader, host) {
        this.element = element;
        this.data = {};
        this.links = {};
        this.loader = loader;
        this.host = host;
        this.init();
    }

    initLinkClickEvents() {
        const links = this.element.querySelectorAll('.js-page-link');

        for (const link of links) {
            link.addEventListener('click', event => {
                event.preventDefault();

                const href = event.target.href.indexOf(this.host.path) !== -1 ? event.target.href : `${ this.host.path }/${event.target.href}`
                this.refreshData(href);
            });
        }
    }

    refreshData(url) {
        this.setLoading(true);
        this.getFeed(url).then((response) => {
            this.setLoading(false);
            this.data = response.data.pagination_object;
            this.links = response.data.pagination_links;

            while (this.element.childNodes.length > 1) {
                this.element.removeChild(this.element.lastChild);
            }

            this.fillHtml(this.data.data, this.links);
            this.initLinkClickEvents();
        });
    }

    async getFeed(url) {
        return await axios.get(url);
    }

    setLoading(loading) {
        if (loading) {
            this.element.classList.add('loading');
            this.loader.classList.remove('inactive');
        } else {
            this.element.classList.remove('loading');
            this.loader.classList.add('inactive');
        }
    }

    fillHtml(data, links) {

        if (data.forEach) {
            data.forEach((value) => this.element.insertAdjacentHTML('beforeend', value));
        } else {
            Object.keys(data).forEach((value) => {
                this.element.insertAdjacentHTML('beforeend', data[value]);
            });
        }
        this.element.insertAdjacentHTML('beforeend', links);
    }

    init() {
        this.setLoading(true);
        this.refreshData(`${ this.host.path }/feeds/meesterbaan?page=1`);
    }
}
